"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendBrowseTrackingEvent = void 0;
var _1 = require(".");
/**
 * Sends an event that a track browse item
 * Event name: "web:browse:item::click"
 */
var sendBrowseTrackingEvent = function (eventInfo) {
    (0, _1.sendEvent)("browse", "item", null, "click", eventInfo);
};
exports.sendBrowseTrackingEvent = sendBrowseTrackingEvent;
